import React, { ReactNode } from 'react';
import Box, { TBoxProps } from '../Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';

type THubControlProps = {
  onClick?: () => void;
  href?: string;
  target?: string;
  children: ReactNode;
  isErrored?: boolean;
  id?: string;
};

type TBaseProps = {
  as: TBoxProps['as'];
  type?: 'button';
  onClick?: THubControlProps['onClick'];
  href?: THubControlProps['href'];
};

const HubControl = ({ onClick, href, isErrored, ...rest }: THubControlProps) => {
  const baseProps: TBaseProps = {
    as: !href ? 'button' : 'a',
    ...(!href && { type: 'button' }),
    onClick,
    href,
  };

  const conditionalProps = filterConditionalKeyValues({
    states: isErrored && 'errored',
  });

  return <Box {...rest} {...baseProps} {...conditionalProps} name="HubControl" />;
};

export default React.memo(HubControl);
